import { combineReducers } from "redux"
import bookingPlugin from './booking-plugin'
import leaguesPlugin from './leagues-plugin'
import leaguePlugin from './league-plugin'
import registrationPlugin from './registration-plugin'

const plugin = combineReducers({
  bookingPlugin, leaguesPlugin, leaguePlugin, registrationPlugin
})

export default plugin
